
import { Vue, Component, Prop } from 'vue-property-decorator';
import { TermsDetails } from '@/features/terms-and-conditions/types';

@Component
export default class TermsForm extends Vue {
  @Prop({ required: true }) termsDetails!: TermsDetails | null;

  @Prop({ default: false }) isLoading!: boolean;

  @Prop({ default: false }) isRemindLaterLoading!: boolean;

  get terms(): string {
    return this.termsDetails?.terms || '';
  }
}
